import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, distinctUntilChanged, filter, finalize, first, forkJoin, from, map, merge, mergeMap, of, skip, take, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProfileAboutService } from './profile-about.service';
import { Profile } from 'src/app/shared/interfaces/profile.interface';
import { ErrorHandlingService, JwtService, ProfileService } from '../index.service';
import { IAnalyze } from 'src/app/shared/interfaces/analyze.interface';
import { IOrgan } from 'src/app/shared/interfaces/organ.interface';

enum ProfileDataItems {
  NAME = 'NAME',
  STUDENT = 'STUDENT',
  EMPLOYEE = 'EMPLOYEE',
  CERTIFICATION = 'CERTIFICATION',
  SKILL = 'SKILL',
  CITY = 'CITY',
  LANGUAGE_SKILL = 'LANGUAGE_SKILL',
  YEAR_OF_BIRTH = 'YEAR_OF_BIRTH',
  NATIONAL_ID = 'NATIONAL_ID'
}

export type ProfileDataItemTypes = keyof typeof ProfileDataItems
export type IsHaveData = {
  profileData: boolean;
  requiredData: boolean;
  requiredQuizes: boolean;
}
export type RequiredQuizType = {
  [key:string]: {
    isCompleted: boolean;
    properties: QuizType;
  }
}
export type MyStatus = {
  analysed_username: string;
  status: string;
  updated_at: string;
}

type QuizType = {
  "name": string;
  "is_active": boolean;
  "username": string;
  "price": number;
  "management_style": string;
  "summary": string;
  "profile_photo": string;
  "banner_photo": string;
  "output_type": string;//"PERCENTAGE"|"POINT",
  "internal_note": string;
}

export type RequiredDataItem = {type:string, name:string, id:number, values:{value:{value:string}}[]}

@Injectable({
  providedIn: 'root'
})
export class CompleteFormService {
  readonly BASE_URL = environment.BASE_API_URL;
  readonly QUIZ_API_URL = environment.QUIZ_API_URL;

  private backButton:{url:string, type:string}|null = null
  setBackButton(value:{url:string, type:string}|null){
    this.backButton = value
  }
  getBackButton():{url:string, type:string}|null{
    return this.backButton
  }

  errorSub:BehaviorSubject<any> = new BehaviorSubject(null);
  errorObs:Observable<any> = this.errorSub.asObservable().pipe(
    skip(1),
  );
  setError(err:any):void{
    this.errorSub.next(err)
  }
  getErrorObs():Observable<any>{
    return this.errorObs
  }  

  profileDataSub:BehaviorSubject<ProfileDataItemTypes> = new BehaviorSubject(<any>[])
  profileDataObs$:Observable<ProfileDataItemTypes> = this.profileDataSub.asObservable().pipe(
    distinctUntilChanged(),
  )
  setYearOfBirth(year:number|string){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      YEAR_OF_BIRTH: year,
    })
  }
  setCIty(data:any){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      CITY: data,
    })
  }
  setNationalId(code:number|string){
    this.profileDataSub.next({
      ...<any>this.profileDataSub.value,
      NATIONAL_ID: code,
    })
  }
  getProfileDataObs():Observable<ProfileDataItemTypes>{
    return this.profileDataObs$
  }
  profileDataRequirement:any[] = []
  requiredDataValuesSub:BehaviorSubject<any> = new BehaviorSubject(null)
  requiredDataValuesObs$:Observable<any> = this.requiredDataValuesSub.asObservable()
  setRequiredDataValuesSub(value:any):void{
    this.requiredDataValuesSub.next(value)
  }
  getRequiredDataValuesObs():Observable<any>{
    return this.requiredDataValuesObs$
  }

  requiredDataSub:BehaviorSubject<RequiredDataItem[]> = new BehaviorSubject(<any>[])
  requiredDataObs$:Observable<RequiredDataItem[]> = this.requiredDataSub.asObservable()
  getRequiredDataObs():Observable<RequiredDataItem[]>{
    return this.requiredDataObs$
  }
  isHaveDataSub:BehaviorSubject<IsHaveData> = new BehaviorSubject(<IsHaveData>{});
  isHaveDataObs$:Observable<IsHaveData> = this.isHaveDataSub.asObservable().pipe(
    distinctUntilChanged(),
    // skip(1),
    )
  // setIsHaveDataSub(isHaveData:IsHaveData):void{
  //   this.isHaveDataSub.next(isHaveData)
  // }
  setIsIhaveProfileDataSub(isHaveData:boolean):void{
    this.isHaveDataSub.next(<IsHaveData>{...this.isHaveDataSub.value, profileData: isHaveData})
  }
  setIsIhaveRequiredDataSub(isHaveData:boolean):void{
    this.isHaveDataSub.next(<IsHaveData>{...this.isHaveDataSub.value, requiredData: isHaveData})
  }
  setIsHaveRequiredQuizesSub(isHaveData:boolean):void{
    this.isHaveDataSub.next(<IsHaveData>{...this.isHaveDataSub.value, requiredQuizes: isHaveData})
  }
  getIsHaveDataObs():Observable<IsHaveData>{
    return this.isHaveDataObs$
  }

  requiredQuizesSub:BehaviorSubject<RequiredQuizType> = new BehaviorSubject(<any>[]);
  requiredQuizesObs$:Observable<RequiredQuizType> = this.requiredQuizesSub.asObservable().pipe(
    // skip(1),
    distinctUntilChanged(),
  )

  constructor(
    private http:HttpClient,
    private profileAboutService:ProfileAboutService,
    private profileService:ProfileService,
    private jwtService:JwtService,
    private errorHadling:ErrorHandlingService,
  ) { }


  //status of form that is completed that or not
  myStatusSub:BehaviorSubject<MyStatus> = new BehaviorSubject(<MyStatus>{});
  myStatusObs$:Observable<MyStatus> = this.myStatusSub.asObservable().pipe(
    // skip(1),
    distinctUntilChanged(),
  )
  isFormCompleted(id:string):Observable<any>{
    let headers = new HttpHeaders()
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        if(account.last_logined_role=='ORGAN'){
          headers = headers.append('Organ-Username',account.username)
        }
        return account
      }),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.get<any>(`${this.QUIZ_API_URL}analysis/form/submit/${id}/my_status/`,{headers}).pipe(
          map((item:any)=>{
            return {...item,account:account}
          }),
          catchError(err=>{
            throw {error:err,account:account}
          })
        )
      })
    )
  }
  setMyStatusSub(status:MyStatus):void{
    this.myStatusSub.next(status);
  }
  getMyStatusObs():Observable<MyStatus>{
    return this.myStatusObs$
  }
  
  addProfileDataItem(data:any, type:'edu'|'cert'|'language'|'skill'|'work'|undefined):void{
    let prevData:any = this.profileDataSub.value
    // this.profileDataSub.next(prevData)
    switch(type){
      case 'edu':
        prevData['STUDENT'].push(data)
        break;
      case 'cert':
        prevData['CERTIFICATION'].push(data)
        break;
      case 'skill':
        prevData['SKILL'].push(data)
        break;
      case 'work':
        prevData['EMPLOYEE'].push(data)
        break;
      case 'language':
        prevData['LANGUAGE_SKILL'].push(data)
        break;
    }
  }
  allRoles:any = {}
  setAllRoles(data:any){
    this.allRoles = data
  }
  getAllRoles(){
    return this.allRoles
  }
  //get all data part of profile required data
  setAllProfileRequiredData(id:string, isCompleted:boolean=false):Observable<any>{
    let tmpProfileData:any = {}
    let tmpRolesData:any = {}
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((accountData:any)=> accountData && accountData.username ),
      mergeMap((accountData:Profile)=>{
        return this.getRequiredProfileData(id).pipe(
          mergeMap((dataList:any[])=>{
            if(dataList.length<=0){
              this.profileDataSub.next(tmpProfileData)
              this.setAllRoles(tmpRolesData)
              return of([])
            }
            this.profileDataRequirement = dataList.map((d:any)=>{return {id:d.id, isRequired: d.is_required, type:d.type}})
            return from(dataList).pipe(
              mergeMap((data:{type:ProfileDataItemTypes, is_required: boolean, id:string, values:any[]})=>{
                tmpProfileData[data.type] = this.convertProfileDataItemInstanceToSTD(data.type, data.values);
                tmpRolesData[data.type] = this.convertProfileDataItemInstanceToSTD(data.type, data.values);
                this.setAllRoles(tmpRolesData)
                if(isCompleted){
                  return of(data)
                }     
                return this.getItems(data.type, accountData.username, accountData).pipe(
                  map((r:any)=>{
                    if(r && r.results)
                      return r.results
                    else
                      return r
                  }),
                  tap(i=>{
                    if(i?.length<=0)
                      tmpProfileData[data.type] = null
                    else
                      tmpProfileData[data.type] = i
                    // console.log(data.type, i)
                  })
                )
              })
            ).pipe(
              finalize(()=>{
                this.profileDataSub.next(tmpProfileData)
              })
            )
          })
        ) 
      }),
      
    )
  }
  convertProfileDataItemInstanceToSTD(type: ProfileDataItemTypes, data:any){
    let output:any = []
    switch(type){
      case 'CERTIFICATION':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              image:null,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'EMPLOYEE':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              image:null,
              additional_data: d.value.value,
            })
          }); 
        }
        break;
      case 'STUDENT':
        if(data.length!=0){
          data.forEach((d:any, index: number) => {
            output.push({
              id: d.value.value.id,
              image: null,
              additional_data: d.value.value,
            })
          });
        }
        break;  
      case 'LANGUAGE_SKILL':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'SKILL':
        if(data.length!=0){
          data.forEach((d:any, index:number) => {
            output.push({
              id: d.value.value.id,
              additional_data: d.value.value,
            })
          });
        }
        break;
      case 'YEAR_OF_BIRTH':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'CITY':
        if(data.length!=0) output = data[0].value.value
        break;
      case 'NATIONAL_ID':
        if(data.length!=0) output = data[0].value.value
    }
    return output
  }
  getItems(type:ProfileDataItemTypes, username:string, currentUser:Profile):Observable<any>{
      switch(type){
        case(ProfileDataItems.STUDENT):
          return this.profileAboutService.getStudentsInfo(username).pipe(
            tap(i=>{
              // console.log('student', i)
            })
          )
        case(ProfileDataItems.CERTIFICATION):
          return this.profileAboutService.getCertifications(username).pipe(
            tap(i=>{
              // console.log('certification', i)
            })
          )
        case(ProfileDataItems.EMPLOYEE):
          return this.profileAboutService.getEmployees(username).pipe(
            tap(i=>{
              // console.log('employee', i)
            })
          )
        case(ProfileDataItems.LANGUAGE_SKILL):
          return this.profileAboutService.getLanguageSkills(username).pipe(
            tap(i=>{
              // console.log('language skill', i)
            })
          )
        case(ProfileDataItems.SKILL):
          return this.profileAboutService.getSkills(username).pipe(
            tap(i=>{
              // console.log('skill', i)
            })
          ) 
        case(ProfileDataItems.NAME):
          return of(`${currentUser.first_name} ${currentUser.last_name}`).pipe(
            tap(i=>{
              // console.log('name', i)
            })
          )
        case(ProfileDataItems.YEAR_OF_BIRTH):
          return this.profileAboutService.getUserAdditionalData(username).pipe(
            map((data:any)=>data.year_of_birth),
            tap(i=>{
              // console.log('year of birth', i)
            })
          )
        case(ProfileDataItems.NATIONAL_ID):
          return this.profileAboutService.getUserAdditionalData(username).pipe(
            map((data:any)=>data.national_id),
            tap(i=>{
              // console.log('year of birth', i)
            })
          )
        case(ProfileDataItems.CITY):
          return this.profileService.getProfile(username).pipe(
            map((data:any)=>data.city),
            mergeMap((city:any)=>{
              return of(city)
            }),
            tap(i=>{
              // console.log('year of birth', i)
            })
          )
        default:
          return of(null)
      }
  }
  //get required section is completed or not
  // setIsHaveRequiredData(id:number){
  //   let isHave:IsHaveData = {
  //     profileData: false,
  //     requiredQuizes: false,
  //     requiredData: false,
  //   }
  //   return merge(
  //     this.isHaveTheProfileRequiredData(id).pipe(
  //       tap((i:{result: boolean})=>{
  //         isHave.profileData = i.result;
  //       })
  //     ),
  //     this.isHaveTheRequiredData(id).pipe(
  //       tap((i:{result: boolean})=>{
  //         isHave.requiredData = i.result;
  //       })
  //     ),
  //     this.isHaveTheRequiredQuizes(id).pipe(
  //       tap((i:{result: boolean})=>{
  //         isHave.requiredQuizes = i.result;
  //       })
  //     )
  //   ).pipe(
  //     catchError((err)=>{
  //       this.setError(this.errorHadling.getErrorObj(err))
  //       throw err
  //     }),
  //     finalize(()=>this.isHaveDataSub.next(isHave))
  //   )
  // }
  isHaveTheProfileRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/is_have_the_profile_required_data/`)
  }
  isHaveTheRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/is_have_the_required_data/`);
  }
  isHaveTheRequiredQuizes(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/is_have_the_required_quizes/`);
  }
  isICompleteExams(exams:string[]):Observable<any>{
    return this.jwtService.getCurrentAccountDataObs().pipe(
      first(),
      filter((response:any)=>response&&response.username),
      map((account:Profile)=>account.username),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get(`${this.BASE_URL}quiz/multiple_criteria/result/?exam__username__in=${exams.join()}&user_username=${username}`)
      }),
      tap((i:any)=>{
        i.forEach((j:any)=>this.setRequiredQuize(j.exam.username))
      }),
      finalize(()=>{this.setIsHaveRequiredQuizesSub((Object.values(this.requiredQuizesSub.value).findIndex(q=>!q.isCompleted)<=-1))})
    )
  }

  //get required sections
  getRequiredProfileData(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/profile_required_data/`);
  }
  
  getRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/required_data/`).pipe(
      tap((i:any)=>this.requiredDataSub.next(<RequiredDataItem[]>i)),
    )
  }
  initRequiredQuizes(formId:string):Observable<RequiredQuizType>{
    return this.getRequiredQuizes(formId).pipe(
      mergeMap((requiredQuizes:any)=> this.isICompleteExams(Object.keys(requiredQuizes)))
    )
  }
  getRequiredQuizes(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/required_quizes/`).pipe(
      map((i:any)=>{
        let rq:RequiredQuizType = {}
        i.forEach((item:QuizType)=>{
          rq[item.username] = {
            isCompleted: false,
            properties: item
          }
        })
        this.requiredQuizesSub.next(rq)
        return rq
      }),
    )
  }
  getRequiredQuizesObs():Observable<RequiredQuizType>{
    return this.requiredQuizesObs$;
  }
  setRequiredQuize(quizUsername:string, isCompleted:boolean=true):void{
    let requiredQuizesInstance: RequiredQuizType = this.requiredQuizesSub.value
    if(requiredQuizesInstance[quizUsername] && requiredQuizesInstance[quizUsername].isCompleted == false){
      requiredQuizesInstance[quizUsername].isCompleted = isCompleted
      this.requiredQuizesSub.next(requiredQuizesInstance)
    }
  }

  //submit form sections
  initalSubmition(id:string):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/initial_submission/`, {})
  }
  submitProfileRequiredData(id:string):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/submit_profile_required_data/`, {}).pipe(
      tap(i=>this.isHaveDataSub.next({...this.isHaveDataSub.value, profileData: true}))
    )
  }
  submitRequiredData(id:string, f:FormData):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/submit_required_data/`, f).pipe(
      tap(i=>this.isHaveDataSub.next({...this.isHaveDataSub.value, requiredData: true}))
    )
  }
  drafRequiredData(id:string, f:FormData):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/draft/`, f)
  }
  drafProfileData(id:string, f:FormData):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/draft_profile/`, f)
  }
  getDrafRequiredData(id:string):Observable<any>{
    return this.http.get(`${this.BASE_URL}quiz/analysis/form/${id}/draft/`)
  }
  submitExamResult(id:string):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/submit_exam_result/`, {}).pipe(
      tap(i=>this.isHaveDataSub.next({...this.isHaveDataSub.value, requiredQuizes: true}))
    )
  }
  completeSubmission(id:string):Observable<any>{
    return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/complete_submission/`, {})
  }
  filterProfileDataSelected(list:any){
    let arrList:any = []
    list.forEach((item:any)=>{
      arrList.push(item)
    })
    return arrList
  }
  submitAll(id:string):Observable<any>{
    return of(this.getAllRoles()).pipe(
      first(),
      mergeMap((profileData:any)=>{
        return this.getRequiredDataValuesObs().pipe(
          first(),
          map((requiredData)=>{return {pData:profileData, rData:requiredData}}),
          mergeMap((data:any)=>{
            if(!data.pData && !data.rData){
              return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/submit/`,{})
            }else{
              let finalData:any = {}
              if(data.pData){
                Object.entries(data.pData).forEach(
                  (item:any)=>{
                    if(item[0]=='CITY' || item[0]=='YEAR_OF_BIRTH' || item[0]=='NATIONAL_ID'){
                      finalData[item[0]] = item[1]
                    }else{
                      finalData[item[0]] = this.filterProfileDataSelected(item[1])
                    }
                  }
                )
              }
              if(data.rData){
                finalData = {...finalData,...data.rData}
              }
              return this.http.post(`${this.BASE_URL}quiz/analysis/form/${id}/submit/`, finalData)
            }
          })
        )
      })
    )
  }
  getSingleFormById(form_id:string):Observable<IAnalyze>{
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_API_URL}analysis/form/${form_id}/`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getFormStepsListStatus(form_id:string):Observable<IAnalyze>{
    let headers:any = new HttpHeaders();
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      map(account=>{
        headers = this.setHeaders(account)
        return account.username
      }),
      distinctUntilChanged(),
      mergeMap((username:string)=>{
        return this.http.get<IAnalyze>(`${this.QUIZ_API_URL}analysis/form/${form_id}/extra_data/`,{headers}).pipe(
          catchError(err=>{throw err})
        )
      })
    )
  }
  getEntityData(username:string): Observable<IOrgan>{
    return this.http.get<any>(`${this.BASE_URL}organ/?username=${username}`).pipe(
      catchError((err=>{throw err})),
      map(i=>i.results)
    )
  }
  setHeaders(account:any){
    let headers = new HttpHeaders()
    if(account.last_logined_role=='ORGAN'){
      headers = headers.append('Organ-Username',account.username)
    }
    return headers
  }

  resetData():void{
    this.setError(null)
    this.profileDataSub.next(<any>[])
    this.setRequiredDataValuesSub(null)
    this.requiredDataSub.next([])
    this.isHaveDataSub.next(<IsHaveData>{})
    this.requiredQuizesSub.next(<any>[])
    this.myStatusSub.next(<MyStatus>{})
  }
}
